import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#26A9D3',
        secondary: '#424242',
        accent: '#109B7C',
        error: '#FF5252',
        info: '#2196F3',
        success: '#239240',
        warning: '#F0931E'
      }
    }
  }
})
